import { DateTime } from 'luxon';

/**
 * Shared helpers for the Connect campaign lists (SMS + Email).
 */

const formatCampaignDate = (iso) => {
    const dt = DateTime.fromISO(iso || '');
    return dt.isValid ? dt.toLocaleString(DateTime.DATETIME_MED) : '';
};

const senderName = (campaign) => {
    const sender = campaign?.Sender;
    if(!sender) return 'System';
    return [sender.firstName, sender.lastName].filter(Boolean).join(' ') || 'System';
};

//Sender People object for Avatar, or null for system/automated sends
const senderProfile = (campaign) => campaign?.Sender || null;

//Map campaign status strings to theme color variants
const statusColorVariant = (status) => {
    const s = (status || '').toLowerCase();
    if(['completed', 'complete', 'sent', 'delivered', 'success'].includes(s)) return 'success';
    if(['failed', 'error'].includes(s)) return 'error';
    if(['sending', 'pending', 'queued', 'processing', 'in_progress', 'scheduled'].includes(s)) return 'warning';
    return 'textSecondary';
};

//Scheduled campaigns should not query live delivery until their send time has passed.
const shouldFetchDeliveryStatus = (campaign) => {
    if(campaign?.status !== 'scheduled') return true;
    const scheduledAt = campaign?.scheduledFor ? new Date(campaign.scheduledFor).getTime() : NaN;
    return !Number.isFinite(scheduledAt) || scheduledAt <= Date.now();
};

//Notes that mark an SMS recipient as "skipped" rather than "failed".
//Mirrors the strings written by the send-sms edge function.
const SMS_SKIP_NOTES_PREFIXES = [
    'No opted-in phone number',
    'Could not normalize phone number',
    'Invalid phone number',
    'Duplicate phone',
];

//Classify an SMSCampaignRecipients row into 'sent' | 'failed' | 'skipped'.
const recipientStatus = (recipient) => {
    if(recipient?.succeeded) return 'sent';
    const notes = recipient?.notes || '';
    if(SMS_SKIP_NOTES_PREFIXES.some(prefix => notes.startsWith(prefix))) return 'skipped';
    return 'failed';
};

export { formatCampaignDate, senderName, senderProfile, statusColorVariant, shouldFetchDeliveryStatus, recipientStatus };
